import login from './login/reducer';

export {
  login
};



// WEBPACK FOOTER //
// ./src/store/reducers.js